import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imags/home/icon_logo.png'
import _imports_1 from '@/assets/imags/home/icon_project.png'
import _imports_2 from '@/assets/imags/home/Icon-Settings.png'
import _imports_3 from '@/assets/imags/home/marksItem.png'
import _imports_4 from '@/assets/default.png'


const _withScopeId = n => (_pushScopeId("data-v-f9607dca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emulator_container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"header flex_between flex_align_center\" data-v-f9607dca><div data-v-f9607dca><img class=\"logo\" src=\"" + _imports_0 + "\" alt=\"\" data-v-f9607dca><img class=\"icon_project\" src=\"" + _imports_1 + "\" alt=\"\" data-v-f9607dca><span class=\"page_name\" data-v-f9607dca>Linux Emulator</span><span style=\"display:none;\" data-v-f9607dca>test 1.1</span></div><div class=\"flex\" data-v-f9607dca><div class=\"circle\" data-v-f9607dca></div><div class=\"circle\" data-v-f9607dca></div><div class=\"circle\" data-v-f9607dca></div></div></div>", 1)
const _hoisted_3 = { class: "home" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "version" }
const _hoisted_6 = { class: "tools flex" }
const _hoisted_7 = { class: "search_box" }
const _hoisted_8 = {
  key: 0,
  class: "ant-form-item-required"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "book_marks" }
const _hoisted_12 = { class: "flex_between book_marks_tools" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "book_marks_title" }, "Bookmarks", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Add + ")
const _hoisted_15 = { class: "book_marks_list" }
const _hoisted_16 = { class: "text_right top_contain fs0" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top_icon",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 1,
  class: "book_marks_list_item_icon",
  src: _imports_4,
  alt: ""
}
const _hoisted_23 = { class: "book_marks_list_item_title" }
const _hoisted_24 = { class: "book_marks feature_app" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex_between book_marks_tools" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "book_marks_title" }, "Featured App")
], -1))
const _hoisted_26 = { class: "book_marks_list" }
const _hoisted_27 = { class: "text_right top_contain fs0" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "top_icon",
  src: "@/assets/imags/home/marksItem.png",
  alt: ""
}, null, -1))
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 1,
  class: "book_marks_list_item_icon",
  src: _imports_4,
  alt: ""
}
const _hoisted_34 = { class: "book_marks_list_item_title" }
const _hoisted_35 = { class: "footer" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, "© Zeasn Linux app emulator", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_AddBookmarks = _resolveComponent("AddBookmarks")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_SettingModal = _resolveComponent("SettingModal")!
  const _component_Liscense = _resolveComponent("Liscense")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.systemTitle) + " ", 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.emulatorVersion), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.requestIconShow)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", {
            class: "serchInput",
            onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toLinkApp && _ctx.toLinkApp(...args)), ["enter"])),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.appLink) = $event)),
            placeholder: "Please enter your App URL:",
            type: "text"
          }, null, 544), [
            [_vModelText, _ctx.appLink]
          ]),
          _createElementVNode("span", {
            class: "clear",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearSearchValue && _ctx.clearSearchValue(...args)))
          }, "X")
        ]),
        _createElementVNode("span", {
          class: "search_icon",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toLinkApp && _ctx.toLinkApp(...args)))
        }, "GO"),
        _createElementVNode("div", {
          class: "setting_icon flex_center",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openSetting && _ctx.openSetting(...args)))
        }, _hoisted_10)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_a_button, {
            shape: "circle",
            onClick: _ctx.addBookmarks
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "book_marks_list_item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_a_dropdown, {
                  placement: "bottomRight",
                  trigger: ['click']
                }, {
                  overlay: _withCtx(() => [
                    _createVNode(_component_a_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "text_center",
                              onClick: ($event: any) => (_ctx.toEdit(item))
                            }, "Edit", 8, _hoisted_18)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_a_divider),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "text_center",
                              onClick: ($event: any) => (_ctx.removeBook(item.appId))
                            }, "Remove", 8, _hoisted_19)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", {
                class: "text_center flex_center",
                onClick: ($event: any) => (_ctx.enterToApp(item.appUrl))
              }, [
                (item.appIcon)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "book_marks_list_item_icon",
                      src: item.appIcon,
                      alt: ""
                    }, null, 8, _hoisted_21))
                  : (_openBlock(), _createElementBlock("img", _hoisted_22))
              ], 8, _hoisted_20),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_a_tooltip, { placement: "top" }, {
                  title: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(item.appName), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(item.appName), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fatureAppList, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (index < 4)
                ? (_openBlock(), _createElementBlock("div", {
                    class: "book_marks_list_item",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_a_dropdown, {
                        placement: "bottomRight",
                        trigger: ['click']
                      }, {
                        overlay: _withCtx(() => [
                          _createVNode(_component_a_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_menu_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "text_center",
                                    onClick: ($event: any) => (_ctx.toEdit(item))
                                  }, "Edit", 8, _hoisted_29)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_divider),
                              _createVNode(_component_a_menu_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "text_center",
                                    onClick: ($event: any) => (_ctx.removeBook(item.appId))
                                  }, "Remove", 8, _hoisted_30)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_28
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("div", {
                      class: "text_center flex_center",
                      onClick: ($event: any) => (_ctx.enterToApp(item.appUrl))
                    }, [
                      (item.appIcon)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "book_marks_list_item_icon",
                            src: item.appIcon,
                            alt: ""
                          }, null, 8, _hoisted_32))
                        : (_openBlock(), _createElementBlock("img", _hoisted_33))
                    ], 8, _hoisted_31),
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_a_tooltip, { placement: "top" }, {
                        title: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(item.appName), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(item.appName), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ])
      ]),
      _createVNode(_component_a_modal, {
        width: "4rem",
        visible: _ctx.bookMarkData.show,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bookMarkData.show) = $event)),
        footer: null,
        closable: false,
        title: "Bookmark",
        centered: ""
      }, {
        default: _withCtx(() => [
          (_ctx.bookMarkData.show)
            ? (_openBlock(), _createBlock(_component_AddBookmarks, {
                key: 0,
                data: _ctx.bookMarkData,
                onOnCancel: _ctx.addCancel,
                onOnSubmit: _ctx.addSuccess
              }, null, 8, ["data", "onOnCancel", "onOnSubmit"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_a_modal, {
        class: "setting_modal",
        width: "5.6rem",
        visible: _ctx.settingVisible,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.settingVisible) = $event)),
        closable: false,
        footer: null,
        centered: ""
      }, {
        default: _withCtx(() => [
          (_ctx.settingVisible)
            ? (_openBlock(), _createBlock(_component_SettingModal, {
                key: 0,
                onOnCancel: _ctx.settingCancel,
                onOnSubmit: _ctx.settingSubmit
              }, null, 8, ["onOnCancel", "onOnSubmit"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_a_modal, {
        class: "license",
        footer: null,
        visible: _ctx.isShowLegal,
        "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isShowLegal) = $event)),
        title: "License Agreement",
        centered: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Liscense)
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _hoisted_36,
      _createElementVNode("span", {
        class: "legal",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showLegal && _ctx.showLegal(...args)))
      }, "Legal")
    ])
  ]))
}